import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CancelIcon from '@mui/icons-material/Cancel';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import CloseIcon from '@mui/icons-material/Close';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FenceIcon from '@mui/icons-material/Fence';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Button,
  createSvgIcon,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography,
  type SelectChangeEvent
} from '@mui/material';
import Tooltip, { tooltipClasses, type TooltipProps } from '@mui/material/Tooltip';
import { styled, useTheme, type Theme } from '@mui/material/styles';
import { DataGrid, type GridRenderCellParams, type GridRowSelectionModel } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import type React from 'react';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router';
import type { GanadoEnCorral } from '../../api-client/ganado/ganado';
import AppButton from '../../components/ui/AppButton';
import AppDialog from '../../components/ui/AppDialog';
import AppForm from '../../components/ui/AppForm';
import AppMenuItem from '../../components/ui/AppMenuItem';
import ComboBox from '../../components/ui/Combobox';
import HistorialAreteDialog from '../../components/ui/HistorialAreteDialog';
import HistorialCell from '../../components/ui/HistorialCell';
import { useComprasStore } from '../../stores/compras/compra.store';
import { useCorralesStore, type AnimalId } from '../../stores/corrales/corrales.store';
import { useGanadoStore } from '../../stores/ganado/ganado.store';
import { useUIStore } from '../../stores/ui/ui.store';
import BajaDialogo from './BajaDialogo';
import CambioZonaDialogo from './CambioZonaDialogo';
import ParidaDialogo from './ParidaDialogo';
import PreñadaDialogo from './PreñadaDialogo';
import TraspasoIndividualDialogo from './TraspasoIndividualDialogo';
import TraspasoMasivoDialogo from './TraspasoMasivoDialogo';

// const validadorAretes = {
//   temporal: (str: string) => /([a-zA-Z]{1})([0-9]{1,3})/.test(str),
//   siiniga: (str: string) => /(\d{2})(\d{4})(\d{4})/.test(str)
// };
const formateadorAretes = {
  temporal: (str: string) => str?.replace(/([a-zA-Z]{1})([0-9]{1,3})/, '$1-$2')?.toUpperCase(),
  siiniga: (str: string) => str?.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')?.toUpperCase()
};

const filtrosCorrales = [
  { label: 'TODOS', value: 'todos' },
  { label: 'CON GANADO', value: 'conganado' },
  { label: 'SIN GANADO', value: 'singanado' }
];

const getStyles = (theme: Theme) => ({
  dataGridContainer: {
    height: 500,
    maxWidth: '79vw'
  },
  dataGrid: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.background.paper,
    '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell, .MuiDataGrid-iconSeparator': {
      borderRight: `1px solid ${theme.palette.primary.main}`
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 'bold'
    },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
      borderBottom: `1px solid ${theme.palette.primary.main}`
    }
  }
});

const DeathIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8087 34.4115C12.9027 34.4149 13.0126 34.4169 13.1406 34.4168C14.161 34.416 15.1066 34.6465 15.9067 35.176C16.7091 35.7071 17.2028 36.4313 17.5003 37.1398C17.9202 38.1395 17.9997 39.2611 18.0144 40.0706C18.1882 40.118 18.429 40.1696 18.7523 40.2161C20.0582 40.404 21.8855 40.4072 23.9917 40.4054C26.0979 40.4037 27.9252 40.3975 29.2308 40.2075C29.554 40.1605 29.7947 40.1085 29.9684 40.0609C29.9818 39.2513 30.0595 38.1296 30.4777 37.1291C30.7741 36.4202 31.2666 35.6951 32.0682 35.1628C32.8674 34.632 33.8126 34.3999 34.8329 34.3991C34.9609 34.399 35.0709 34.3967 35.1648 34.3932C35.1652 34.302 35.1643 34.1992 35.1623 34.0828C35.1593 33.9119 35.1532 33.7032 35.1462 33.4662C35.1316 32.9676 35.1133 32.3441 35.1128 31.6865C35.111 29.5373 35.8998 28.2926 36.4744 27.3859C36.595 27.1956 36.7062 27.0201 36.7987 26.8542C37.3056 25.945 37.9786 24.3768 37.9751 20.1176C37.9719 16.2022 36.2895 13.3476 33.7554 11.4188C31.1657 9.44774 27.6146 8.40246 23.9655 8.40544C20.3164 8.40843 16.767 9.45953 14.1806 11.4348C11.6497 13.3677 9.97188 16.2251 9.97511 20.1405C9.97861 24.3997 10.6541 25.9669 11.1625 26.8752C11.2553 27.0409 11.3668 27.2162 11.4877 27.4064C12.0638 28.3122 12.8546 29.5556 12.8564 31.7047C12.8569 32.3624 12.8397 32.9859 12.8259 33.4846C12.8193 33.7215 12.8135 33.9302 12.8108 34.1011C12.809 34.2175 12.8083 34.3203 12.8087 34.4115ZM10.8279 33.3745C10.7594 35.8206 10.7427 36.4188 13.1423 36.4168C16.0141 36.4145 16.0162 38.9848 16.0176 40.6984C16.019 42.412 19.8908 42.4088 23.9933 42.4054C28.0959 42.4021 31.9677 42.3989 31.9663 40.6853C31.9649 38.9718 31.9628 36.4014 34.8346 36.3991C37.2342 36.3971 37.2165 35.7989 37.1439 33.353C37.1297 32.8717 37.1133 32.3188 37.1128 31.6849C37.1115 30.1595 37.5605 29.4384 38.1031 28.5668C38.932 27.2354 39.9795 25.5529 39.9751 20.116C39.9602 1.8178 7.96003 1.84401 7.97511 20.1422C7.97959 25.5791 9.02986 27.2599 9.86093 28.5899C10.405 29.4606 10.8551 30.181 10.8564 31.7064C10.8569 32.3403 10.8414 32.8932 10.8279 33.3745Z"
        fill="currentColor"
      ></path>{' '}
      <path
        d="M22.2033 27.2179C22.2056 29.8478 20.2177 31.9813 17.7631 31.9832C15.3085 31.985 13.3168 29.8546 13.3145 27.2246C13.3122 24.5947 15.3001 22.4612 17.7547 22.4594C20.2093 22.4575 22.2011 24.588 22.2033 27.2179Z"
        fill="currentColor"
      ></path>{' '}
      <path
        d="M34.6473 27.2062C34.6493 29.8362 32.6611 31.9698 30.2065 31.972C27.7519 31.9741 25.7604 29.8438 25.7584 27.2139C25.7563 24.584 27.7445 22.4503 30.1991 22.4482C32.6537 22.446 34.6452 24.5763 34.6473 27.2062Z"
        fill="currentColor"
      ></path>{' '}
      <path
        d="M26.9886 36.6788C26.9893 37.5734 26.3173 38.4035 25.3962 38.4043C24.7571 38.4048 24.2825 38.033 23.9893 37.5053C23.6969 38.0335 23.223 38.4061 22.5837 38.4066C21.6625 38.4073 20.9893 37.5782 20.9886 36.6838C20.987 34.769 23.9859 33.4054 23.9859 33.4054C23.9859 33.4054 26.9869 34.6817 26.9886 36.6788Z"
        fill="currentColor"
      ></path>{' '}
    </g>
  </svg>,
  'Death'
);

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip describeChild {...props} classes={{ popper: className }} arrow />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 320,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}));

const GestionCorrales = () => {
  const theme = useTheme();
  const classes = getStyles(theme);
  const { gestion, cargarPorCantidadGanado } = useCorralesStore();
  const {
    enCorral,
    cargarPorArete,
    cargarPorCorral,
    quitarDatosBaja,
    quitarDatosParida,
    quitarDatosPreñada
  } = useGanadoStore();
  const { cargarHistorialSiiniga, cargarHistorialTemporal, historialSiiniga, historialTemporal } =
    useComprasStore();
  const { loading } = useUIStore();
  const [filtro, setFiltro] = useState('todos');
  const [openMenuCorral, setOpenMenuCorral] = useState(false);
  const [anchorMenuCorral, setAnchorMenuCorral] = useState<null | HTMLElement>(null);
  const [openMenuAnimal, setOpenMenuAnimal] = useState(false);
  const [anchorMenuAnimal, setAnchorMenuAnimal] = useState<null | HTMLElement>(null);
  const [corralSeleccionado, setCorralSeleccionado] = useState<number | null>(null);
  const [openDialogoPreñada, setOpenDialogoPreñada] = useState(false);
  const [openDialogoParida, setOpenDialogoParida] = useState(false);
  const [openDialogoBaja, setOpenDialogoBaja] = useState(false);
  const [openDialogoCambioZona, setOpenDialogoCambioZona] = useState(false);
  const [openDialogoTraspasoIndividual, setOpenDialogoTraspasoIndividual] = useState(false);
  const [openDialogoTraspasoMasivo, setOpenDialogoTraspasoMasivo] = useState(false);
  const [openHistorialSiiniga, setOpenHistorialSiiniga] = useState(false);
  const [openHistorialTemporal, setOpenHistorialTemporal] = useState(false);
  const [openDialogoConfirmarQuitarStatusBaja, setOpenDialogoConfirmarQuitarStatusBaja] =
    useState(false);
  const [openDialogoConfirmarQuitarStatusPreñada, setOpenDialogoConfirmarQuitarStatusPreñada] =
    useState(false);
  const [openDialogoConfirmarQuitarStatusParida, setOpenDialogoConfirmarQuitarStatusParida] =
    useState(false);
  const [animalSeleccionado, setAnimalSeleccionado] = useState<GanadoEnCorral | null>(null);
  const [traspasoMasivo, setTraspasoMasivo] = useState(false);
  const [animalesSeleccionados, setAnimalesSeleccionados] = useState<Array<AnimalId>>([]);
  const [filtroAnimal, setFiltroAnimal] = useState<'siiniga' | 'temporal'>('siiniga');
  const [valorFiltroAnimal, setValorFiltroAnimal] = useState<string>('');

  const handleFiltroChange = async (event: SelectChangeEvent<any>) => {
    const value = event.target.value;
    setFiltro(String(value));
    setTraspasoMasivo(false);
    setAnimalSeleccionado(null);
    await cargarPorCantidadGanado(String(value));
  };

  const handleCorralSelect = async (id: number) => {
    setCorralSeleccionado(id);
    setAnimalSeleccionado(null);
    setTraspasoMasivo(false);
    setValorFiltroAnimal('');
    await cargarPorCorral(id);
  };

  const handleMenuCorralOpen = (event: React.MouseEvent<HTMLElement>, id: number) => {
    if (corralSeleccionado !== id) {
      handleCorralSelect(id);
    }
    setAnchorMenuCorral(event.currentTarget);
    setOpenMenuCorral(true);
  };

  const handleMenuAnimalOpen = (event: React.MouseEvent<HTMLElement>, animal: GanadoEnCorral) => {
    setAnimalSeleccionado(animal);
    setAnchorMenuAnimal(event.currentTarget);
    setOpenMenuAnimal(true);
  };

  const handleOpenDialogoPreñada = () => {
    setOpenDialogoPreñada(true);
    setOpenMenuAnimal(false);
  };

  const handleOpenDialogoParida = () => {
    setOpenDialogoParida(true);
    setOpenMenuAnimal(false);
  };

  const handleOpenDialogoBaja = () => {
    setOpenDialogoBaja(true);
    setOpenMenuAnimal(false);
  };

  const handleOpenDialogoCambioZona = () => {
    setOpenDialogoCambioZona(true);
    setOpenMenuAnimal(false);
  };

  const handleOpenDialogoTraspasoIndividual = () => {
    setOpenDialogoTraspasoIndividual(true);
    setOpenMenuAnimal(false);
  };

  const handleCloseDialogoTraspasoIndividual = async () => {
    setOpenDialogoTraspasoIndividual(false);
    await handleCorralSelect(animalSeleccionado!.idCorral);
    await cargarPorCantidadGanado(filtro);
  };

  const corralSeleccionadoTieneGanado = () => {
    const corral = gestion.find((c) => c.id === corralSeleccionado);
    return corral ? corral.cantidadGanado > 0 : false;
  };

  const handleIniciaTraspasoMasivo = () => {
    setTraspasoMasivo(true);
    setOpenMenuCorral(false);
  };

  const handleCancelaTraspasoMasivo = () => {
    setTraspasoMasivo(false);
  };

  const handleOpenDialogoTraspasoMasivo = () => {
    setOpenDialogoTraspasoMasivo(true);
  };

  const handleCloseDialogoTraspasoMasivo = async () => {
    setTraspasoMasivo(false);
    setOpenDialogoTraspasoMasivo(false);
    setAnimalesSeleccionados([]);
    await handleCorralSelect(corralSeleccionado!);
    await cargarPorCantidadGanado(filtro);
  };

  const handleInputKey = async (code: string) => {
    if (code === 'Escape') {
      setValorFiltroAnimal('');
    }
    if (code === 'Enter') {
      await buscarPorArete();
    }
  };

  const handleClickHistorialSiiniga = (folio: string, partida: number) => {
    cargarHistorialSiiniga(folio, partida).then(() => setOpenHistorialSiiniga(true));
  };
  const handleClickHistorialTemporal = (folio: string, partida: number) => {
    cargarHistorialTemporal(folio, partida).then(() => setOpenHistorialTemporal(true));
  };

  const handleConfirmQuitarStatusBaja = (animal: GanadoEnCorral) => {
    setAnimalSeleccionado(animal);
    setOpenDialogoConfirmarQuitarStatusBaja(true);
  };

  const handleQuitarStatusBaja = async () => {
    await quitarDatosBaja({
      partida: animalSeleccionado?.partida!,
      folioInterno: animalSeleccionado?.folioInterno!,
      idCorral: animalSeleccionado?.idCorral!
    });
    setOpenDialogoConfirmarQuitarStatusBaja(false);
  };

  const handleConfirmQuitarStatusPreñada = (animal: GanadoEnCorral) => {
    setAnimalSeleccionado(animal);
    setOpenDialogoConfirmarQuitarStatusPreñada(true);
  };

  const handleQuitarStatusPreñada = async () => {
    await quitarDatosPreñada({
      partida: animalSeleccionado?.partida!,
      folioInterno: animalSeleccionado?.folioInterno!,
      idCorral: animalSeleccionado?.idCorral!
    });
    setOpenDialogoConfirmarQuitarStatusPreñada(false);
  };

  const handleConfirmQuitarStatusParida = (animal: GanadoEnCorral) => {
    setAnimalSeleccionado(animal);
    setOpenDialogoConfirmarQuitarStatusParida(true);
  };

  const handleQuitarStatusParida = async () => {
    await quitarDatosParida({
      partida: animalSeleccionado?.partida!,
      folioInterno: animalSeleccionado?.folioInterno!,
      idCorral: animalSeleccionado?.idCorral!
    });
    setOpenDialogoConfirmarQuitarStatusParida(false);
  };

  useEffect(() => {
    cargarPorCantidadGanado(filtro);
  }, []);

  const buscarPorArete = async () => {
    if (valorFiltroAnimal.length > 0) {
      const ganado = await cargarPorArete(filtroAnimal, valorFiltroAnimal);
      setCorralSeleccionado(ganado?.idCorral ?? null);
    }
  };

  return (
    <>
      <AppForm title="Gestión de Corrales">
        <Grid size={12}>
          <Grid container direction="row" spacing={2}>
            <Grid size={2}>
              <Stack direction="column" spacing={2}>
                <ComboBox
                  label="Corrales"
                  value={filtro}
                  options={filtrosCorrales}
                  onChange={handleFiltroChange}
                  disabled={loading}
                />
                <List>
                  {gestion.map((corral) => (
                    <ListItem
                      key={corral.id}
                      disablePadding
                      divider={true}
                      secondaryAction={
                        <IconButton edge="end" onClick={(e) => handleMenuCorralOpen(e, corral.id)}>
                          <MoreVertIcon />
                        </IconButton>
                      }
                    >
                      <ListItemButton
                        dense
                        role={undefined}
                        selected={corralSeleccionado === corral.id}
                        onClick={() => handleCorralSelect(corral.id)}
                        disabled={loading}
                      >
                        <ListItemText
                          primary={corral.nombre}
                          secondary={`# Animales: ${corral.cantidadGanado}`}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Stack>
            </Grid>
            <Grid size={10}>
              <Grid container direction="column" spacing={2}>
                <Grid>
                  <Grid container direction="row" spacing={2}>
                    <Grid size={5}>
                      <TextField
                        label="Filtro"
                        placeholder="Filtrar por..."
                        value={valorFiltroAnimal}
                        disabled={loading || traspasoMasivo}
                        onChange={(e) => setValorFiltroAnimal(e.target.value)}
                        onKeyDown={(e) => handleInputKey(e.key)}
                        slotProps={{
                          input: {
                            inputProps: {
                              maxLength: 12
                            },
                            endAdornment:
                              valorFiltroAnimal?.length > 0 ? (
                                <>
                                  <IconButton
                                    disabled={loading || traspasoMasivo}
                                    onClick={() => setValorFiltroAnimal('')}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                  <IconButton
                                    disabled={loading || traspasoMasivo}
                                    onClick={buscarPorArete}
                                  >
                                    <SearchIcon />
                                  </IconButton>
                                </>
                              ) : (
                                <></>
                              )
                          }
                        }}
                        fullWidth
                      />
                    </Grid>
                    <Grid size={2}>
                      <ComboBox
                        label=""
                        value={filtroAnimal}
                        disabled={loading || traspasoMasivo}
                        onChange={(e) => setFiltroAnimal(e.target.value)}
                        options={[
                          { value: 'siiniga', label: 'Arete SIINIGA' },
                          { value: 'temporal', label: 'Arete Temporal' }
                        ]}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid>
                  <Box sx={classes.dataGridContainer}>
                    <DataGrid
                      sx={classes.dataGrid}
                      rows={enCorral}
                      loading={loading}
                      getRowId={(row) => `${row.folioInterno}-${row.partida}`}
                      columns={[
                        {
                          field: 'areteSiiniga',
                          headerAlign: 'center',
                          headerName: 'Arete SIINIGA',
                          width: 130,
                          valueFormatter: (value: string | number | null) => {
                            const valueStr = String(value ?? '');
                            return formateadorAretes.siiniga(valueStr);
                          }
                        },
                        {
                          field: 'historialSiiniga',
                          type: 'actions',
                          headerName: '',
                          width: 60,
                          cellClassName: 'actions',
                          renderCell: (params: GridRenderCellParams) => {
                            return (
                              <HistorialCell {...params} onClick={handleClickHistorialSiiniga} />
                            );
                          }
                        },
                        {
                          field: 'areteTemporal',
                          headerAlign: 'center',
                          renderHeader: () => (
                            <Typography variant="body2" align="center" fontWeight="bold">
                              Arete
                              <br />
                              Temporal
                            </Typography>
                          ),
                          width: 100,
                          valueFormatter: (value: string | number | null) => {
                            const valueStr = String(value ?? '');
                            return formateadorAretes.temporal(valueStr);
                          }
                        },
                        {
                          field: 'historialTemporal',
                          type: 'actions',
                          headerName: '',
                          width: 60,
                          cellClassName: 'actions',
                          renderCell: (params: GridRenderCellParams) => {
                            return (
                              <HistorialCell {...params} onClick={handleClickHistorialTemporal} />
                            );
                          }
                        },
                        {
                          field: 'fechaCompra',
                          headerName: 'Fecha Compra',
                          headerAlign: 'center',
                          width: 130,
                          valueFormatter: (value: Date) =>
                            dayjs(value).format('DD MMM YYYY').toLocaleUpperCase()
                        },
                        {
                          field: 'diasEstancia',
                          headerAlign: 'center',
                          renderHeader: () => (
                            <Typography variant="body2" align="center" fontWeight="bold">
                              Días
                              <br />
                              Estancia
                            </Typography>
                          ),
                          width: 100
                        },
                        {
                          field: 'fechaIngreso',
                          headerName: 'Fecha Ingreso',
                          headerAlign: 'center',
                          width: 130,
                          valueFormatter: (value: Date) =>
                            dayjs(value).format('DD MMM YYYY').toLocaleUpperCase()
                        },
                        {
                          field: 'tipoGanado',
                          headerName: 'Tipo Ganado',
                          headerAlign: 'center',
                          width: 240
                        },
                        {
                          field: 'zona',
                          headerName: 'Zona',
                          headerAlign: 'center',
                          width: 100
                        },
                        {
                          headerName: 'Iconografía',
                          headerAlign: 'center',
                          field: 'iconografia',
                          width: 150,
                          renderCell: (params) => {
                            const { cargada, parida, status } = params.row;
                            return (
                              <Box sx={{ display: 'flex', alignItems: 'center', pr: 2, pt: 1.5 }}>
                                {status === 0 && (
                                  <HtmlTooltip
                                    title={
                                      <Stack direction="column" spacing={0.5} mt={1}>
                                        <Typography variant="caption">
                                          {`Fecha de baja: ${dayjs(params.row.fechaBaja).format('DD MMM YYYY').toLocaleUpperCase()}`}
                                        </Typography>
                                        <Typography variant="caption">
                                          {`Notas: ${params.row.bajaNotas}`}
                                        </Typography>
                                        <AppButton
                                          module="gestion-corrales"
                                          permission="quitar-baja"
                                          variant="contained"
                                          color="warning"
                                          disableElevation
                                          onClick={() => handleConfirmQuitarStatusBaja(params.row)}
                                        >
                                          Quitar status
                                        </AppButton>
                                      </Stack>
                                    }
                                  >
                                    <DeathIcon color="action" />
                                  </HtmlTooltip>
                                )}
                                {status === 1 && (
                                  <HtmlTooltip title="Animal en buen estado">
                                    <FavoriteIcon color="error" />
                                  </HtmlTooltip>
                                )}
                                {status === 2 && (
                                  <HtmlTooltip
                                    title={
                                      <Stack direction="column" spacing={0.5} mt={1}>
                                        <Typography variant="caption">
                                          {`Fecha de baja: ${dayjs(params.row.fechaBaja).format('DD MMM YYYY').toLocaleUpperCase()}`}
                                        </Typography>
                                        <Typography variant="caption">
                                          {`Notas: ${params.row.bajaNotas}`}
                                        </Typography>
                                        <AppButton
                                          module="gestion-corrales"
                                          permission="quitar-baja"
                                          variant="contained"
                                          color="warning"
                                          disableElevation
                                          onClick={() => handleConfirmQuitarStatusBaja(params.row)}
                                        >
                                          Quitar status
                                        </AppButton>
                                      </Stack>
                                    }
                                  >
                                    <AttachMoneyIcon color="success" />
                                  </HtmlTooltip>
                                )}
                                {status === 3 && (
                                  <HtmlTooltip
                                    title={
                                      <Stack direction="column" spacing={0.5} mt={1}>
                                        <Typography variant="caption">
                                          {`Fecha de baja: ${dayjs(params.row.fechaBaja).format('DD MMM YYYY').toLocaleUpperCase()}`}
                                        </Typography>
                                        <Typography variant="caption">
                                          {`Notas: ${params.row.bajaNotas}`}
                                        </Typography>
                                        <AppButton
                                          module="gestion-corrales"
                                          permission="quitar-baja"
                                          variant="contained"
                                          color="warning"
                                          disableElevation
                                          onClick={() => handleConfirmQuitarStatusBaja(params.row)}
                                        >
                                          Quitar status
                                        </AppButton>
                                      </Stack>
                                    }
                                  >
                                    <AttachMoneyIcon color="error" />
                                  </HtmlTooltip>
                                )}
                                {cargada && (
                                  <HtmlTooltip
                                    title={
                                      <Stack direction="column" spacing={0.5} mt={1}>
                                        <Typography variant="caption">
                                          {`Fecha de tacto: ${dayjs(params.row.fechaTacto).format('DD MMM YYYY').toLocaleUpperCase()}`}
                                        </Typography>
                                        <Typography variant="caption">
                                          {`Fecha de parto (aproximada): ${dayjs(params.row.fechaParto).format('DD MMM YYYY').toLocaleUpperCase()}`}
                                        </Typography>
                                        <Typography variant="caption">
                                          {`Meses de gestación: ${params.row.mesesGestacion}`}
                                        </Typography>
                                        <Typography variant="caption">
                                          {`Notas: ${params.row.cargadaNotas}`}
                                        </Typography>
                                        <AppButton
                                          module="gestion-corrales"
                                          permission="quitar-preñada"
                                          variant="contained"
                                          color="warning"
                                          disableElevation
                                          onClick={() =>
                                            handleConfirmQuitarStatusPreñada(params.row)
                                          }
                                        >
                                          Quitar status
                                        </AppButton>
                                      </Stack>
                                    }
                                  >
                                    <PregnantWomanIcon color="primary" />
                                  </HtmlTooltip>
                                )}
                                {parida && (
                                  <HtmlTooltip
                                    title={
                                      <Stack direction="column" spacing={0.5} mt={1}>
                                        <Typography variant="caption">
                                          {`Parida: ${params.row.paridaTipo === 1 ? 'PRODUCTO VIVO' : 'PRODUCTO PERDIDO'}`}
                                        </Typography>
                                        <Typography variant="caption">
                                          {`Notas: ${params.row.paridaNotas}`}
                                        </Typography>
                                        <AppButton
                                          module="gestion-corrales"
                                          permission="quitar-parida"
                                          variant="contained"
                                          color="warning"
                                          disableElevation
                                          onClick={() =>
                                            handleConfirmQuitarStatusParida(params.row)
                                          }
                                        >
                                          Quitar status
                                        </AppButton>
                                      </Stack>
                                    }
                                  >
                                    <ChildFriendlyIcon color="primary" />
                                  </HtmlTooltip>
                                )}
                              </Box>
                            );
                          }
                        },
                        {
                          field: 'actions',
                          type: 'actions',
                          headerName: 'Acciones',
                          headerAlign: 'center',
                          width: 100,
                          cellClassName: 'actions',
                          renderCell: (params) => (
                            <IconButton
                              size="small"
                              onClick={(event) => handleMenuAnimalOpen(event, params.row)}
                            >
                              {<MoreVertIcon />}
                            </IconButton>
                          )
                        }
                      ]}
                      autoHeight={false}
                      disableColumnMenu={true}
                      disableColumnSorting={true}
                      disableRowSelectionOnClick={true}
                      disableColumnResize={true}
                      checkboxSelection={traspasoMasivo}
                      disableRowSelectionExcludeModel
                      onRowSelectionModelChange={(model: GridRowSelectionModel) => {
                        const ids = Array.from(model.ids)
                          .map((id) => id.toString().split('-'))
                          .map(([folioInterno, partida]) => ({
                            folioInterno,
                            partida: Number(partida)
                          }));

                        setAnimalesSeleccionados(ids);
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <Stack direction="row" justifyContent="flex-end" spacing={2}>
                {traspasoMasivo && (
                  <>
                    <Button
                      variant="contained"
                      startIcon={<FenceIcon />}
                      disableElevation
                      onClick={handleOpenDialogoTraspasoMasivo}
                      disabled={animalesSeleccionados.length === 0}
                    >
                      Al Corral
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<CancelIcon />}
                      disableElevation
                      onClick={handleCancelaTraspasoMasivo}
                    >
                      Cancelar traspaso
                    </Button>
                  </>
                )}
                <Button
                  variant="contained"
                  startIcon={<ExitToAppIcon />}
                  component={RouterLink}
                  to="/"
                  disableElevation
                >
                  Salir
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </AppForm>
      <Menu
        id="menu-corral"
        anchorEl={anchorMenuCorral}
        open={openMenuCorral}
        onClose={() => setOpenMenuCorral(false)}
      >
        <MenuItem disabled={true}>Despachar comederos</MenuItem>
        <MenuItem disabled={true}>Revisión comederos</MenuItem>
        <MenuItem disabled={true}>Medicina inicial</MenuItem>
        <AppMenuItem
          module="gestion-corrales"
          permission="traspaso-ganado-masivo"
          disabled={!corralSeleccionadoTieneGanado()}
          onClick={handleIniciaTraspasoMasivo}
        >
          Traspaso masivo
        </AppMenuItem>
      </Menu>
      <Menu
        id="menu-animal"
        anchorEl={anchorMenuAnimal}
        open={openMenuAnimal}
        onClose={() => setOpenMenuAnimal(false)}
      >
        <MenuItem disabled={true}>Medicina inicial</MenuItem>
        <MenuItem disabled={true}>Medicina curativa</MenuItem>
        <MenuItem disabled={animalSeleccionado?.status !== 1} onClick={handleOpenDialogoBaja}>
          Baja
        </MenuItem>
        <AppMenuItem
          module="gestion-corrales"
          permission="traspaso-ganado"
          disabled={animalSeleccionado?.status !== 1}
          onClick={handleOpenDialogoTraspasoIndividual}
        >
          Traspaso
        </AppMenuItem>
        <MenuItem
          disabled={animalSeleccionado?.status !== 1 || animalSeleccionado?.cargada}
          onClick={handleOpenDialogoPreñada}
        >
          Preñada
        </MenuItem>
        <MenuItem
          disabled={
            animalSeleccionado?.status !== 1 ||
            !animalSeleccionado?.cargada ||
            animalSeleccionado?.parida
          }
          onClick={handleOpenDialogoParida}
        >
          Parida
        </MenuItem>
        <AppMenuItem
          module="gestion-corrales"
          permission="cambiar-zona"
          onClick={handleOpenDialogoCambioZona}
        >
          Cambiar zona
        </AppMenuItem>
      </Menu>
      {openDialogoPreñada && (
        <PreñadaDialogo
          open={openDialogoPreñada}
          onClose={() => setOpenDialogoPreñada(false)}
          animal={animalSeleccionado!}
        />
      )}
      {openDialogoParida && (
        <ParidaDialogo
          open={openDialogoParida}
          onClose={() => setOpenDialogoParida(false)}
          animal={animalSeleccionado!}
        />
      )}
      {openDialogoBaja && (
        <BajaDialogo
          open={openDialogoBaja}
          onClose={() => setOpenDialogoBaja(false)}
          animal={animalSeleccionado!}
        />
      )}
      {openDialogoTraspasoIndividual && (
        <TraspasoIndividualDialogo
          open={openDialogoTraspasoIndividual}
          onClose={handleCloseDialogoTraspasoIndividual}
          animal={animalSeleccionado!}
        />
      )}
      {openDialogoTraspasoMasivo && (
        <TraspasoMasivoDialogo
          open={openDialogoTraspasoMasivo}
          onClose={handleCloseDialogoTraspasoMasivo}
          idCorralOrigen={corralSeleccionado!}
          animales={animalesSeleccionados}
        />
      )}
      {openDialogoCambioZona && (
        <CambioZonaDialogo
          open={openDialogoCambioZona}
          onClose={() => setOpenDialogoCambioZona(false)}
          animal={animalSeleccionado!}
        />
      )}
      <HistorialAreteDialog
        titulo="SIINIGA"
        historial={historialSiiniga}
        open={openHistorialSiiniga}
        onClose={() => setOpenHistorialSiiniga(false)}
        formatter={(arete) => formateadorAretes.siiniga(arete)}
      />
      <HistorialAreteDialog
        titulo="TEMPORAL"
        historial={historialTemporal}
        open={openHistorialTemporal}
        onClose={() => setOpenHistorialTemporal(false)}
        formatter={(arete) => formateadorAretes.temporal(arete)}
      />
      <AppDialog
        open={openDialogoConfirmarQuitarStatusBaja}
        onClose={() => setOpenDialogoConfirmarQuitarStatusBaja(false)}
        title="Confirme"
        message="¿Está seguro de quitar el status de baja?"
        buttons={
          <>
            <Button
              color="secondary"
              variant="contained"
              disableElevation
              onClick={handleQuitarStatusBaja}
            >
              Sí
            </Button>
            <Button
              variant="contained"
              disableElevation
              onClick={() => setOpenDialogoConfirmarQuitarStatusBaja(false)}
            >
              No
            </Button>
          </>
        }
      />
      <AppDialog
        open={openDialogoConfirmarQuitarStatusPreñada}
        onClose={() => setOpenDialogoConfirmarQuitarStatusPreñada(false)}
        title="Confirme"
        message="¿Está seguro de quitar el status de preñada?"
        buttons={
          <>
            <Button
              color="secondary"
              variant="contained"
              disableElevation
              onClick={handleQuitarStatusPreñada}
            >
              Sí
            </Button>
            <Button
              variant="contained"
              disableElevation
              onClick={() => setOpenDialogoConfirmarQuitarStatusPreñada(false)}
            >
              No
            </Button>
          </>
        }
      />
      <AppDialog
        open={openDialogoConfirmarQuitarStatusParida}
        onClose={() => setOpenDialogoConfirmarQuitarStatusParida(false)}
        title="Confirme"
        message="¿Está seguro de quitar el status de parida?"
        buttons={
          <>
            <Button
              color="secondary"
              variant="contained"
              disableElevation
              onClick={handleQuitarStatusParida}
            >
              Sí
            </Button>
            <Button
              variant="contained"
              disableElevation
              onClick={() => setOpenDialogoConfirmarQuitarStatusParida(false)}
            >
              No
            </Button>
          </>
        }
      />
    </>
  );
};

export default GestionCorrales;
